import React, { useEffect, useState, useRef } from "react";
import { Autocomplete, TextField, Chip } from "@mui/material";
import { GetMultiSelectClients } from "../../services/ClientsMaintenanceService";
import { NotificationManager } from "react-notifications";
import CommonLoader from "./CommonLoader";


const MultiSelectClients = ({ value, onChange, refreshToken = 0 }) => {
  const [clients, setClients] = useState([]);
  const [selectedClients, setSelectedClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const isPatching = useRef(false); // guard flag

  useEffect(() => {
    fetchData(refreshToken > 0);
  }, [refreshToken]);

  useEffect(() => {
    if (clients.length > 0) {
      isPatching.current = true;
      patchNewValues(clients);
    }
  }, [value, clients]);

  useEffect(() => {
    if (isPatching.current) {
      isPatching.current = false;
      return; // skip onChange during patch
    }
    if (onChange) {
      const clientIds = selectedClients.join(",");
      onChange(clientIds);
    }
  }, [selectedClients]); // intentionally omit onChange from deps

  const fetchData = async (forceRefresh = false) => {
    try {
      setLoading(true);
      const response = await GetMultiSelectClients("", forceRefresh);
      const clientsData = response.results.map((client) => ({
        accountNumber: client.accountNumber.trim(),
        clientName: client.clientName.trim(),
      }));
      setClients(clientsData);
      setLoading(false);
    } catch (error) {
      NotificationManager.error("Error fetching clients:", error);
      setLoading(false);
    }
  };

  const patchNewValues = (clientsData) => {
    if (value && clientsData.length > 0) {
      const accountNumbersArray = value.split(",").map((id) => id.trim()).filter(Boolean);
      setSelectedClients(accountNumbersArray);
    }
  };

  return (
    <>
      <Autocomplete
        multiple
        options={clients}
        getOptionLabel={(option) =>
          `${option.accountNumber} - ${option.clientName}`
        }
        value={selectedClients
          .map((accountNumber) =>
            clients.find((client) => client.accountNumber === accountNumber)
          )
          .filter(Boolean)} // prevent undefined entries
        fullWidth
        size="small"
        isOptionEqualToValue={(option, value) =>
          option.accountNumber === value.accountNumber
        }
        onChange={(event, newValue) => {
          isPatching.current = false; // user action — allow onChange
          setSelectedClients(newValue.map((client) => client.accountNumber));
        }}
        renderTags={(selected, getTagProps) =>
          selected.map((option, index) => (
            <Chip
              key={index}
              label={`${option.accountNumber} - ${option.clientName}`}
              {...getTagProps({ index })}
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label="Clients"
            variant="outlined"
            margin="dense"
          />
        )}
      />
      <CommonLoader loading={loading} />
    </>
  );
};

export default MultiSelectClients;